import { createFileRoute } from "@tanstack/react-router";
import { ComplianceWorkspace } from "@/components/AdditionalWorkspaces";

export const Route = createFileRoute("/compliance")({ component: ComplianceWorkspace });
